import { CompanyInterface } from '../model/CompanyInterface';
import axios from 'axios';

export const getCompany = async (sourceBranch: string): Promise<CompanyInterface> => {
  const { data } = await axios.get<CompanyInterface>(`${process.env.REACT_APP_API_URL}/${sourceBranch}/company.json`);

  return data as CompanyInterface;
};
